module.exports = __webpack_public_path__ + "img/greatpurple.33ed86d5.png";